import Vue from 'vue'
import Router from 'vue-router'
// import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'page404',
      component: () => import('./views/404.vue')
    },
    // {
    //   path: '/:cid/:token',
    //   name: 'login',
    //   component: () => import('./views/Login.vue'),
    //   props: true
    // },
    {
      path: '/:cid/:token',
      name: 'contractDefault',
      component: () => import('./views/ContractDefault.vue'),
      props: true
    },
    {
      path: '/contract/:cid/:token',
      name: 'contract',
      component: () => import('./views/Contract.vue'),
      props: true
    },
    {
      path: '/success/:cid/:token/:contractNo',
      name: 'success',
      component: () => import('./views/Success.vue'),
      props: true
    },
    {
      path: '/email/:cid/:token',
      name: 'email',
      component: () => import('./views/Email.vue'),
      props: true
    }
  ]
})
